// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e678ed8f","453":"74ebec03","455":"84aeb1ff","977":"f8330fb1"}[chunkId] + ".chunk.js";
};